"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _isReactNode = _interopRequireDefault(require("../_utils/isReactNode"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _normalizeAddon = function _normalizeAddon(addon) {
  if (addon == null) {
    return Object.freeze({});
  }

  if ((0, _isReactNode.default)(addon)) {
    return {
      after: addon
    };
  }

  return addon;
};

var Input = function (_React$Component) {
  (0, _inherits2.default)(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Input);
    _this = _super.call(this, props);

    _this.handleChange = function (e) {
      if (_this.props.value === undefined) {
        _this.setState({
          value: e.currentTarget.value
        });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this._attachRef = function ($$input) {
      _this.inputRef.current = $$input;

      if (_this.props.innerRef) {
        if (typeof _this.props.innerRef === 'function') {
          _this.props.innerRef($$input);
        } else {
          _this.props.innerRef.current = $$input;
        }
      }
    };

    var value = '';

    if (props.value !== undefined) {
      var _props$value;

      value = (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : '';
    } else if (props.defaultValue !== undefined) {
      var _props$defaultValue;

      value = (_props$defaultValue = props.defaultValue) !== null && _props$defaultValue !== void 0 ? _props$defaultValue : '';
    }

    _this.state = {
      value: value
    };
    _this.inputRef = React.createRef();
    return _this;
  }

  (0, _createClass2.default)(Input, [{
    key: "focus",
    value: function focus() {
      var $$input = this.inputRef.current;

      if (!$$input) {
        return;
      }

      $$input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      var $$input = this.inputRef.current;

      if (!$$input) {
        return;
      }

      $$input.blur();
    }
  }, {
    key: "select",
    value: function select(start, length) {
      var $$input = this.inputRef.current;

      if (!$$input) {
        return;
      }

      $$input.focus();

      if (start === undefined) {
        $$input.select();
        return;
      }

      if (Number.isNaN(start)) {
        start = 0;
      }

      var totalLength = $$input.value.length;

      if (start < 0) {
        start = totalLength - Math.abs(start);

        if (start < 0) {
          start = 0;
        }
      }

      var end = totalLength;

      if (length !== undefined) {
        if (Number.isNaN(length) || length < 0) {
          length = 0;
        }

        end = start + length;
      }

      $$input.setSelectionRange(start, end);
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      var _this$props = this.props,
          disabled = _this$props.disabled,
          className = _this$props.className;
      var nativeProps = (0, _omit.default)(this.props, ['innerRef', 'defaultValue', 'addon']);

      var addon = _normalizeAddon(this.props.addon);

      var _className = (0, _classnames.default)(className, 'Input', {
        'Input--disabled': disabled,
        'Input--with-addon': addon.before || addon.after
      });

      return React.createElement("span", {
        className: _className
      }, addon.before && React.createElement("span", {
        className: "Input__addon Input__addon--before"
      }, addon.before), React.createElement("input", Object.assign({}, nativeProps, {
        className: "Input__input",
        onChange: this.handleChange,
        value: value,
        ref: this._attachRef
      })), addon.after && React.createElement("span", {
        className: "Input__addon Input__addon--after"
      }, addon.after));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var nextValue = nextProps.value !== null ? nextProps.value : '';

      if (nextValue !== undefined && prevState.value !== nextValue) {
        return {
          value: nextValue
        };
      }

      return null;
    }
  }]);
  return Input;
}(React.Component);

Input.isFormControl = true;
Input.defaultProps = {
  type: 'text',
  defaultValue: undefined,
  value: undefined,
  disabled: false,
  addon: undefined,
  onChange: undefined,
  className: undefined,
  innerRef: undefined
};
var _default = Input;
exports.default = _default;